
export interface Locale {
  code: string
  order: number
  name: string
}

const LOCALES: Locale[] = [
  {
    code: 'en',
    order: 1,
    name: 'English',
  },
  {
    code: 'de',
    order: 2,
    name: 'German',
  },
  {
    code: 'fr',
    order: 2,
    name: 'French',
  },
  {
    code: 'pt',
    order: 3,
    name: 'Portuguese (Portugal)',
  },
  {
    code: 'ar',
    order: 4,
    name: 'Arabic',
  },
]


export const getLocales = () => LOCALES.sort((a, b) => a.order - b.order)